import React from 'react';
import './Card.css';

/*
 * Card — the mock's `.card` surface (border + radius + shadow).
 *   pad      : boolean | 'sm'  -> adds .card--pad (20px) or .card--pad-sm (16px 18px)
 *   title    : optional heading (rendered in a .card__head bar with a bottom border)
 *   subtitle : optional sub line under the title
 *   actions  : optional node placed at the right of the head bar
 *   header   : full custom head node (overrides title/subtitle/actions)
 *   footer   : optional footer node (rendered in a bordered .card__foot)
 * Children are the body. When a title/header is present, the body sits in a
 * padded region unless `flush` is set (e.g. for a table that draws its own padding).
 */
export default function Card({
  pad = false,
  title,
  subtitle,
  actions,
  header,
  footer,
  flush = false,
  as: Tag = 'div',
  className = '',
  bodyClassName = '',
  children,
  ...rest
}) {
  const hasHead = header != null || title != null || actions != null;
  const cls = [
    'card',
    'ui-card',
    pad === true ? 'card--pad' : '',
    pad === 'sm' ? 'card--pad-sm' : '',
    hasHead || footer ? 'ui-card--sectioned' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <Tag className={cls} {...rest}>
      {hasHead && (
        <div className="ui-card__head">
          {header != null ? header : (
            <>
              <div className="grow">
                {title != null && <div className="h-sec">{title}</div>}
                {subtitle != null && <div className="sub">{subtitle}</div>}
              </div>
              {actions != null && <div className="ui-card__actions">{actions}</div>}
            </>
          )}
        </div>
      )}
      {hasHead || footer
        ? <div className={`ui-card__body${flush ? ' ui-card__body--flush' : ''}${bodyClassName ? ' ' + bodyClassName : ''}`}>{children}</div>
        : children}
      {footer != null && <div className="ui-card__foot">{footer}</div>}
    </Tag>
  );
}
